
<template>
   <el-dialog width="70%" title="工程地址" :visible.sync="addressflag" append-to-body>
        <div id="container" style="width: 100%;height: 360px;"></div>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                addressflag : false,
                WeChatimg : 'https://www.91worker.cn/wxstatic/images/wechat.jpg'
            }
        },
        mounted() {},
        methods: {
           mapstate(data){
                this.addressflag = true;
                this.init(data);
            },
             init(data){
                var center = new qq.maps.LatLng(data.lat,data.lng);
                var map = new qq.maps.Map(document.getElementById('container'),{
                    center: center,
                    zoom: 13
                });
                //创建marker
                var marker = new qq.maps.Marker({
                    position: center,
                    map: map
                });
                if(document.getElementById('container') == null){
                    setTimeout(function () {
                        var center = new qq.maps.LatLng(data.lat,data.lng);
                        var map = new qq.maps.Map(document.getElementById('container'),{
                            center: center,
                            zoom: 13
                        });
                        //创建marker
                        var marker = new qq.maps.Marker({
                            position: center,
                            map: map
                        });
                    }, 100)
                    console.log(document.getElementById('container'));
                }
            },
            
            clearOverlays(overlays) {
                let overlay;
                while (overlay = overlays.pop()) {
                    overlay.setMap(null);
                }
            },
        }
    }
</script>